import s from './footer-links.module.scss';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

const links = [
  {
    href: '/terms',
    text: 'firstFooter',
  },
  {
    href: '/privacy',
    text: 'secondFooter',
  },
  // {
  //   href: '/refund',
  //   text: 'thirdFooter',
  // },
  {
    href: '/contacts',
    text: 'fourthFooter',
  },
];

const FooterLinks = () => {
  const t = useTranslations('Common');

  return (
    <div className={s.footerLinks}>
      {links.map((l) => (
        <Link
          className={s.columnHeader}
          prefetch={false}
          href={l.href}
          key={l.href}
        >
          {t(l.text)}
        </Link>
      ))}
    </div>
  );
};

export default FooterLinks;
